import { FC, MouseEvent } from 'react'
import { useChatContext, useIsChatEnabled } from 'react-common'
import { useTranslation } from 'react-i18next'
import { SvgComponent } from '@platform/ui'
import { API_BASE } from 'apps-common'
import { useIsMobile } from '@/hooks/useIsMobile'
import styles from './NotificationIndicator.module.scss'

type NotificationIndicatorProps = {
  announcementChannelId: string
}

export const NotificationIndicator: FC<NotificationIndicatorProps> = (props) => {
  const { announcementChannelId } = props
  const { t, i18n } = useTranslation()

  const { getUnreadCountByChannelId, openChatWindow } = useChatContext()

  const unreadCount = getUnreadCountByChannelId(announcementChannelId)

  const isRTL = i18n.dir() === 'rtl'

  const isChatEnabled = useIsChatEnabled()

  const isMobile = useIsMobile()

  if (!isChatEnabled) {
    return null
  }

  if (!unreadCount) {
    return null
  }

  if (!announcementChannelId) {
    return null
  }

  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()

    const channelUrl = `${window.location.protocol}${window.location.host}${API_BASE.PLATFORM}chat/channels/groups/${announcementChannelId}`
    openChatWindow(channelUrl)
  }

  const unreadCountText = t('chatNotification.count', { count: unreadCount })

  return (
    <div className={styles.notificationIndicatorWrapper}>
      <button className={styles.button} onClick={handleClick}>
        <span className={styles.relative}>
          <SvgComponent name="NotificationBoldStroke" size="sm" />
          {unreadCount > 0 && <i className={styles.redDot} />}
        </span>

        {unreadCount > 0 && (
          <span className={styles.countText}>
            {isMobile ? unreadCount : unreadCountText}
            {!isMobile && <SvgComponent name={isRTL ? 'ChevronLeftBoldStroke' : 'ChevronRightBoldStroke'} size="sm" />}
          </span>
        )}
      </button>
    </div>
  )
}
